<div class="view-history" *ngIf="historyPdfs">
  <assess-expandable-list
    data-testid="show-hide-history"
    [items]="historyPdfs"
    [visibleItems]="0"
    viewMoreLabel="Show Form History"
    viewLessLabel="Hide Form History"
  >
    <ng-template let-item>
      <div class="flex-row flex-space-btw">
        <div>
          <div class="pdf-history-date-and-status">
            <span>{{ item.snapshotRequest.createdAt | formatDate }}</span> &bull;
            <span>{{ item.snapshotRequest.formStatus }}</span>
          </div>
          <div class="pdf-history-user-name">
            {{ item.snapshotRequest.user?.data?.firstName }} {{ item.snapshotRequest.user?.data?.lastName }}
          </div>
        </div>
        <div class="view-form" [ngSwitch]="item.snapshotRequest.jobStatus">
          <span *ngSwitchDefault class="in-progress" data-testid="in-progress"
            ><mat-icon>picture_as_pdf</mat-icon> PDF Generation In Progress...</span
          >
          <span *ngSwitchCase="JobStatus.Error" class="failed" data-testid="failed"
            ><mat-icon>picture_as_pdf</mat-icon> PDF Generation Failed</span
          >
          <button
            *ngSwitchCase="JobStatus.Complete"
            mat-button
            color="primary"
            (click)="showPdf(item.attachment)"
            data-testid="view-pdf"
          >
            View
          </button>
        </div>
      </div>
    </ng-template>
  </assess-expandable-list>
</div>
